import React from 'react'
import { useTranslation } from 'react-i18next'

const ContactSection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <section
            style={{
                padding: '100px 20px',
                backgroundColor: '#f4f2e8',
                textAlign: 'center'
            }}
        >
            <h2 style={{ fontSize: '2rem' }}>{t('contact.title')}</h2>
            <a
                href="https://wa.me/996555309509"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'inline-block',
                    marginTop: '2rem',
                    marginRight: '20px',
                    width: '64px',
                    height: '64px'
                }}
            >
                <img
                    src="https://cdn-icons-png.flaticon.com/256/185/185988.png"
                    alt="WhatsApp"
                    width="64"
                    height="64"
                />
            </a>
            <a
                href="https://t.me/vanlifekg"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'inline-block',
                    marginTop: '2rem',
                    width: '64px',
                    height: '64px'
                }}
            >
                <img
                    src="https://cdn-icons-png.freepik.com/256/2111/2111646.png"
                    alt="telegram"
                    width="64"
                    height="64"
                />
            </a>
        </section>
    )
}

export default ContactSection
